import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import UserForm from '../UserForm';
import Page from '../Page';
import PageSection from '../PageSection';
import Popup from '../Popup';

const validationObject = [
	{
		"fieldName": "first_name",
		"required": true,
		"errorMessage": "First name"
	},
	{
		"fieldName": "last_name",
		"required": true,
		"errorMessage": "Last name"
	},
	{
		"fieldName": "company",
		"required": true,
		"errorMessage": "Company name"
	},
	{
		"fieldName": "pp_user_email",
		"required": true,
		"errorMessage": "Email address"
	},
	{
		"fieldName": "phone",
		"required": true,
		"errorMessage": "Phone number"
	},
	{
		"fieldName": "website",
		"required": true,
		"errorMessage": "Website"
	}
];

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class Settings extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.validationObject = validationObject;
		this.state = {
			user: this.Auth.getProfile(),
			errors: []
		}

		this.onChange = this.onChange.bind(this);
		this.submitUserForm = this.submitUserForm.bind(this);
		this.validateForm = this.validateForm.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
	}

	onChange(e) {
		this.setState({
			user: {
				...this.state.user,
				[e.target.name]: e.target.value
			}
		});
	}

	validateForm() {
		let validCount = this.validationObject.length;
		let errors = [];
		let stateErrors = {};
		let hasErrors = false;

		for(let i=0; i<validCount; i++) {
			if(this.validationObject[i].required) {
				if( !this.state.user[this.validationObject[i].fieldName]) {
					let message = this.validationObject[i].errorMessage;
					errors.push(<p>{message}</p>);
					stateErrors[this.validationObject[i].fieldName] = true;
					hasErrors = true;
				}
			}
		}

		if(hasErrors) {
			this.showMessage(errors, "Please complete these required fields");
			this.setState({
				errors: stateErrors
			});
		}

		return !hasErrors;
	}

	submitUserForm(e) {
		let formData = new FormData();
		const { user } = this.state;
		let user_id = user.pp_user_id;
		var target = e.target;

		formData.append("user", JSON.stringify(user));

		// TODO: check that all fields are valid or required as needed
		if(user_id !== null && this.validateForm()) {
			this.loadingButton(target);
			// update the user
			this.Auth.post('/pp-users/update/' + user_id, formData)
			.then(
				(result) => {
					console.log(result);
					this.removeLoadingButton(target);
					if(result.success) {
						this.showMessage("Your profile has been updated.");
						this.Auth.setProfile(user);
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.removeLoadingButton(target);
					this.showMessage('Something went wrong. Please try again later.');
					this.setState({
						error
					});
				}
			);
		}
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	loadingButton(target) {
		target.disabled = true;
		target.classList.add('pp-loading');
	}

	removeLoadingButton(target) {
		target.disabled = false;
		target.classList.remove('pp-loading');
	}

	render() {
		const {
			user,
		 	message
		} = this.state;

		return (
			<Page pageTitle="Edit Settings" pageClass="pp-settings-page">

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				<PageSection sectionTitle="Profile Information">
					<UserForm
						user={user}
						onChange={this.onChange}
						errors={this.state.errors}
					/>
					<div className="pp-action-buttons">
						<button className="pp-update-profile" onClick={this.submitUserForm}>Update</button>
					</div>
				</PageSection>

			</Page>
		);
	}
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/pages/Settings.js